import { Injectable } from '@angular/core';
import {  HttpGeneralService} from '../../shared/shared';

import { CONFIG } from '../../shared/config';
let usersPrivilegesUrl = CONFIG.baseUrls.UsersPrivilege;
let usersSecLoginsUrl = CONFIG.baseUrls.usersGroups;
let usersServiceUrl = CONFIG.baseUrls.UsersService;

export interface UsersPrivilege {

    serial: number,
    secLoginId: number,
    // roleId: number,
    vplacesId: number,
    placeType: number,
    selected: boolean

}

export interface UsersService {
    id: number,
    secLoginId: number,
    serviceId: number,
    selected: boolean
}

@Injectable()
export class UsersPrivilegeService {
    constructor(private httpGeneralService: HttpGeneralService) {

    }
       //pagination
    getUsers(pageSize: number, offset: number) {
        return this.httpGeneralService.getWith(`${usersPrivilegesUrl}/getUsers/${pageSize}/${offset}`);
    }

    //get all last level of services by parentCode
    getServices(serviceCode: number) {
        return this.httpGeneralService.get(serviceCode, usersServiceUrl);
    }

    getSecLogins() {
        return this.httpGeneralService.getWith(`${usersSecLoginsUrl}/secLogin`);
    }

    addUsersPrivilege(usersPrivilege: UsersPrivilege[]) {
        return this.httpGeneralService.addCollection(usersPrivilege, usersPrivilegesUrl);
    }
    addUsersService(userService: UsersService[]) {
        return this.httpGeneralService.addCollection(userService, usersServiceUrl);
    }

    deleteUsersPrivilege(usersPrivilege: UsersPrivilege) {
        return this.httpGeneralService.delete(usersPrivilege.serial, usersPrivilegesUrl);
    }


}
